export default __webpack_public_path__ + "static/media/job_offer16_xl.8613ed5d.jpg";